module.exports = __webpack_public_path__ + "assets/img/advantage@2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/card-logo/advantage@2x.png
// module id = 48
// module chunks = 0